import { Permission } from 'garaje/utils/ui-permissions';

const ACCOUNT_MANAGEMENT = {
  'Manage billing details': [Permission.ACCOUNT_MANAGEMENT_BILLING_SETTINGS_MANAGE],
};

const ANALYTICS = {
  'View Deliveries analytics': [
    Permission.ANALYTICS_LOCAL_DELIVERIES_DASH_READ,
    Permission.ANALYTICS_LOCAL_DELIVERIES_DASH_EXPORT,
  ],
  'View Desks analytics': [Permission.ANALYTICS_LOCAL_DESKS_DASH_READ, Permission.ANALYTICS_LOCAL_DESKS_DASH_EXPORT],
  'View Visitors analytics': [
    Permission.ANALYTICS_LOCAL_VISITORS_DASH_READ,
    // Permission.ANALYTICS_LOCAL_VISITORS_DASH_EXPORT, // - not present in app/utils/ui-permissions.ts
  ],
};

const DELIVERIES = {
  'Add deliveries (mobile app)': [
    /* permissions not yet implemented */
  ],
  'Edit and delete deliveries': [
    /* permissions not yet implemented */
  ],
  'View all deliveries': [
    /* permissions not yet implemented */
  ],
};

const DESKS = {
  'Manage desk reservations': [
    /* permissions not yet implemented */
  ],
  'Manage desk settings': [
    /* permissions not yet implemented */
  ],
  'Manage desks & neighborhoods': [
    /* permissions not yet implemented */
  ],
};

const MAPS = {
  'Manage live maps & neighborhoods': [
    /* permissions not yet implemented */
  ],
};

const USER_MANAGEMENT = {
  'View admins': [Permission.USER_MANAGEMENT_ADMIN_READ, Permission.USER_MANAGEMENT_CUSTOM_ROLE_READ],
};

const VISITORS = {
  'Add visitor entries': [Permission.VISITORS_ENTRY_CREATE],
  'Delete all invites': [Permission.VISITORS_INVITE_DELETE],
  'Edit all invites': [Permission.VISITORS_INVITE_UPDATE, Permission.VISITORS_PRINTER_READ],
  'Edit visitor entries': [Permission.VISITORS_ENTRY_UPDATE, Permission.VISITORS_PRINTER_READ],
  'Export all invites': [Permission.VISITORS_INVITE_EXPORT],
  'Export all visitor entries': [Permission.VISITORS_ENTRY_EXPORT],
  'View all invites': [Permission.VISITORS_INVITE_READ],
  'View all visitor entries': [Permission.VISITORS_ENTRY_READ],
  'View devices': [
    Permission.VISITORS_DEVICE_READ,
    Permission.VISITORS_PRINTER_NAV,
    Permission.VISITORS_PRINTER_READ,
    Permission.VISITORS_PRINTER_CONNECTION_READ,
    // Permission.VISITORS_PRINTER_PASSCODE_READ, // - not present in app/utils/ui-permissions.ts
  ],
};

const WORKPLACE = {
  'Export employee log': [
    /* permissions not yet implemented */
  ],
  'Manage employee log': [
    /* permissions not yet implemented */
  ],
};

const COMMUNICATIONS = {
  'Send and manage messages': [
    Permission.COMMUNICATIONS_ANNOUNCEMENT_CREATE,
    Permission.COMMUNICATIONS_ANNOUNCEMENT_READ,
    Permission.COMMUNICATIONS_ANNOUNCEMENT_UPDATE,
    Permission.COMMUNICATIONS_ANNOUNCEMENT_DELETE,
    Permission.COMMUNICATIONS_ANNOUNCEMENT_TEMPLATE_READ,
  ],
  'Manage message templates': [
    Permission.COMMUNICATIONS_ANNOUNCEMENT_TEMPLATE_CREATE,
    Permission.COMMUNICATIONS_ANNOUNCEMENT_TEMPLATE_READ,
    Permission.COMMUNICATIONS_ANNOUNCEMENT_TEMPLATE_UPDATE,
    Permission.COMMUNICATIONS_ANNOUNCEMENT_TEMPLATE_DELETE,
  ],
  'Manage settings': [
    Permission.COMMUNICATIONS_SETTING_CREATE,
    Permission.COMMUNICATIONS_SETTING_READ,
    Permission.COMMUNICATIONS_SETTING_UPDATE,
    Permission.COMMUNICATIONS_SETTING_DELETE,
  ],
};

export default {
  ACCOUNT_MANAGEMENT,
  ANALYTICS,
  DELIVERIES,
  DESKS,
  MAPS,
  USER_MANAGEMENT,
  VISITORS,
  WORKPLACE,
  COMMUNICATIONS,
};
